import React from "react";
import { components } from "react-select";
import { PropTypes } from "prop-types";
import Select from 'react-select';
import { Text } from "@kui/foundations-react";

// react-select styled to sit next to the @kui inputs
const customStyles = {
  container: base => ({
    ...base,
    width: "100%"
  }),
  control: (base, state) => ({
    ...base,
    height: "auto",
    minHeight: 40,
    background: "#fff",
    boxShadow: "none",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: state.isFocused ? "#76b900" : "#a7a7a7",
    borderRadius: 4,
    "&:hover": {
      borderColor: "#76b900"
    }
  }),
  menu: base => ({
    ...base,
    zIndex: 10
  }),
  // the menu is portalled to <body>, so it floats above the checkboxes and buttons below the field
  menuPortal: base => ({
    ...base,
    zIndex: 9999
  }),
  valueContainer: base => ({
    ...base,
    flexWrap: "wrap",
    minWidth: 0
  }),
  multiValue: base => ({
    ...base,
    maxWidth: "100%"
  }),
  option: (base, state) => ({
    ...base,
    textAlign: "left",
    backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
    color: "#000",
    "&:active": {
      backgroundColor: "#e0e0e0"
    }
  }),
  placeholder: base => ({
    ...base,
    color: "#757575"
  })
};

const Menu = props => {
  const optionSelectedLength = props.getValue().length || 0;
  return (
    <components.Menu {...props} >
      {optionSelectedLength < 3 ? (
        props.children
      ) : (
        <div style={{ margin: 15 }}>Max limit achieved</div>
      )}
    </components.Menu>
  );
};

const MulSelectCreatable = props => {
  const res = props.optionValues.map(o => ({ value: o.key, label: o.value }));
  const isValidNewOption = (inputValue, selectValue) =>
    inputValue.length > 0 && selectValue.length < 3;
  // plain wrapper (not FormField): it grows with the selected values instead of keeping
  // a fixed input height, so the selection can never overlap the content below
  const labelId = "mulselect-" + props.labelText.replace(/\W+/g, "-");
  return (
    <div className="regMultiField">
      <Text kind="label/bold/sm" asChild>
        <label id={labelId}>
          {props.labelText}
          {props.isRequired && (
            <span className="regRequiredMark" aria-hidden="true">{" "}*</span>
          )}
        </label>
      </Text>
      <Select
        aria-labelledby={labelId}
        styles={customStyles}
        menuPlacement="auto"
        menuPortalTarget={typeof document !== "undefined" ? document.body : null}
        allowCreateWhileLoading={false}
        onChange={props.onChange}
        components={{ Menu }}
        placeholder={"Select (1-3) options"}
        isMulti
        isValidNewOption={isValidNewOption}
        options={res}
      />
    </div>
  );
}
MulSelectCreatable.propTypes = {
    optionValues: PropTypes.array.isRequired,
    isRequired: PropTypes.bool,
    labelText: PropTypes.string.isRequired,
    id: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func.isRequired,

    readOnly: PropTypes.bool,
    displayFieldName: PropTypes.string,
    valueFieldName: PropTypes.string
  };
  Menu.propTypes = {
  getValue: PropTypes.func.isRequired,
  children:PropTypes.node,
  }
export default MulSelectCreatable;
